import { Component, Inject, OnInit } from '@angular/core';
import { HttpService } from 'src/app/service/http/http.service';
import { Config } from 'src/app/app-constant';
import { ColDef, ExcelExportParams,GridReadyEvent, ISetFilterParams, themeQuartz, ValueFormatterParams } from 'ag-grid-community';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { formatText } from 'src/app/shared/commen-function-file';
import { DatePipe } from '@angular/common';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';
import { CommentDialogComponent } from 'src/app/shared/comment-dialog/comment-dialog.component';
@Component({
  selector: 'app-expense-dashboard-details',
  templateUrl: './expense-dashboard-details.component.html',
  styleUrls: ['./expense-dashboard-details.component.scss'],
})
export class ExpenseDashboardDetailsComponent implements OnInit {
  dropdownSettings: IDropdownSettings = {};
  getStatusList: any = [];
  selectedSatus: any = [];
  currentData: any = [];
  approvedReimbursment: any = [];
  rejectedReimbursment: any = [];
  expenseApproved: any = [];
  penddingReimbursment: any = [];
  employeeData: any = [];
  moduleName: any;
  loggedInUserId: any;
  isToggleOn: boolean = true;
  type: any = "Approved";
  taskColumnHeaderInfoForFinanse: any = []
  allTeamMemberReimbursementApprove: any = []
  approveMatrixValueForCondition: any
  loggedInUserRole: any | null;
  loggedInUserRoles: any;
  employeeApproved: any = []
  employeePendding: any = [];
  employeeRejected: any = [];
  employeApprovedOrRejected: any = [];
  raisedEmployeeUnderManager: any;
  approvedEmployeeUnderManager: any;
  rejectedEmployeeUnderManager: any;
  pendingEmployeeUnderManager: any;
  undeManagerAprrovedreject: any = [];
  employeIDFromUserTable: any = []
  underManagerAprrovedreject: any = [];
  pendingWithManager: any = [];

  formatedataVariable = formatText;
  OnlyFinance: any;
  rejectedEmployeeUnderFinance: any;
  approvedEmployeeUnderFinance: any;
  pendingEmployeeUnderFinance: any;
  raisedEmployeeUnderFinance: any[] = [];
  underFinanceAprrovedreject: any;
  loggedInUserCompanyID: any;
  selectUserIdForManager: any;
  arrEmployeeDetiails: any = [];
  isApprovedByEnabled: boolean = false;
  selectedFromDated: any;
  selectedtoDated: any;
  searchTaskString: string = '';
  loggedInHODManager: any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private datePipe: DatePipe, private httpService: HttpService, private config: Config, private encryptionService: EncryptionService, public mobileResponsiveService: MobileResponsiveService, public dialog: MatDialog) {
console.log("---------------data--------------",data)
    this.arrEmployeeDetiails = data.arrEmployeeDetiails;
    this.loggedInUserId = data.loggdingUserId;
    this.selectUserIdForManager = data.userID;
    this.moduleName = data.moduleName;
    this.selectedFromDated = data.selectedFromDated;
    this.selectedtoDated =  data.selectedtoDated;
  }
 
  ngOnInit() {
    
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInHODManager = sessionStorage.getItem('HODManager');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.getAllEmployeeListing();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };

    this.approveMatrixValueForCondition = this.httpService.passApprovematrixForReport;
    this.hederlable();
    this.getEmployee();

    setTimeout(() => {
      this.OnlyFinance = sessionStorage.getItem('financeAdminId') == this.loggedInUserId;


    }, 0)

  }

  
  // --------------------------------AG GRID CODE---------------------------------------------------------
  gridApi: any;
  paginationPageSizeSelector = [5, 10, 20,50,100,200,500,1000];
  pagination = false;
  paginationPageSize = 10000000;
  detailRowAutoHeight = true;

  defaultColDef: ColDef = {
    flex: 1,
    minWidth: 100,
    filter: true,
    resizable: true,
    sortable: true,
    floatingFilter: false,  // ✅ small filter box under header
  };
  
  gridOptions: any = {
    defaultColDef: {
      resizable: true,
      sortable: true,
      filter: true,
      floatingFilter: true,
      minWidth: 80,
  
      // ✅ add this
      cellClass: (p: any) => (p.node.rowIndex % 2 === 0 ? 'cell-even' : 'cell-odd')
    },
    context: { componentParent: this },
    rowSelection: 'single',
    localeText: {
      noRowsToShow: 'No Data Found'  // default text ko replace karna hai 'No Rows To Show' to 'No Data Found'
    }
  };

  openCommentModal(text: string,commentType:any) {
    this.dialog.open(CommentDialogComponent, {
      width: '600px',
      data: { 
        text: text,
        commentType: commentType
      }
    });
  
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    params.api.sizeColumnsToFit();
    console.log(params)
  }
  formatStatus(value: any): string {
    if (!value || typeof value !== 'string') {
      return 'N/A'; // fallback agar value string na ho
    }

    // Camel Case → Title Case
    return value
      .toLowerCase()
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
  formatDate(value: any): string {
    if (!value) return 'N/A';
  
    const date = new Date(value);
    if (isNaN(date.getTime())) return 'Invalid Date';
  
    // dd-MM-yyyy format
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
  
    return `${day}-${month}-${year}`;
  }
  
  // ✅ Global search function
  onFilterTextBoxChanged(value: string = '') {
    if (!this.gridApi) return;
  
    // v31+ way:
    this.gridApi.setGridOption('quickFilterText', value ?? '');
   
  }
  onBtExport() {
    const params: ExcelExportParams = {
      fileName: 'Expense_Report_' + new Date().toISOString().slice(0, 10) + '.xlsx',
      sheetName: 'ExpenseData',
      exportAsExcelTable: {
        showRowStripes: true,
        name: 'ExpenseTable'
      },
      processCellCallback: (cell) => {
        const header = cell.column.getColDef().headerName;
        const value = cell.value;
  
        // 1. Date Formatting (for specific headers)
        const dateColumns = ['date', 'dateOfExpense']; // <- field names ya headerName use karo

        if (dateColumns.includes(cell.column.getColId()) && cell.value) {
          const date = new Date(cell.value);
          if (!isNaN(date.getTime())) {
            return (
              ('0' + date.getDate()).slice(-2) +
              '-' +
              ('0' + (date.getMonth() + 1)).slice(-2) +
              '-' +
              date.getFullYear()
            );
          }
        }
  
        // 2. Status Formatting (make it human readable)
        if (header === 'Status' && value) {
          return value
            .toString()
            .toLowerCase()
            .replace(/_/g, ' ') // replace underscores with space
            .replace(/\b\w/g, (char:any) => char.toUpperCase()); // capitalize each word
        }
  
        return value;
      }
    };
  
    this.gridApi.exportDataAsExcel(params);
  }
  
   
  approvalRenderer(params: any) {
    if (!params.value) return '';
        const status = params.value.toUpperCase();
      
        let color = '';
        if (status === 'APPROVED') {
          color = '#4caf50'; // green
        } else if (status === 'REJECTED') {
          color = '#f44336'; // red
        } else if (status === 'PENDING') {
          color = '#ff9800'; // orange
        }
      
        return `
          <span style="
            border: 1px solid ${color};
            color: ${color};
            padding: 4px 10px;
            border-radius: 12px;
            font-size: 12px;
            font-weight: 500;
            display: inline-block;
            line-height: 20px;
            white-space: nowrap;
          ">
        ${status.charAt(0) + status.slice(1).toLowerCase()}
      </span>
    `;
  }

  statusFormatter(params: any): string {
    if (!params.value) return '';
  
    const valueUpper = params.value.toUpperCase();
  
    // 🔹 Status → Color map
    const statusColors: Record<string, string> = {
      'APPROVED_BY_FINANCE_BUT_NOT_PAID': '#4caf50', // green
      'APPROVED_BY_MANAGER_SENT_TO_FINANCE': '#4caf50',
      'APPROVED_BY_MANAGER_REJECTED_BY_FINANCE': '#f44336', // red
      'REJECTED_BY_MANAGER': '#f44336',
      'PENDING_WITH_MANAGER': '#ff9800' // orange
    };
  
    // 🔹 Default color = grey
    const color =
      Object.keys(statusColors).find(key => valueUpper.includes(key))
        ? statusColors[
            Object.keys(statusColors).find(key => valueUpper.includes(key))!
          ]
        : '#999';
  
    // 🔹 Convert to Title Case
    const formattedText = params.value
      .toLowerCase()
      .split('_')
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  
    return `
      <span style="
        border: 1px solid ${color};
        color: ${color};
        padding: 4px 10px;
        border-radius: 12px;
        font-size: 12px;
        font-weight: 500;
        display: inline-block;
        white-space: normal;
        word-wrap: break-word;
        line-height: 1.4em;
        animation: fadeInScale 0.3s ease-in-out;
        max-width: 100%;
      ">
        ${formattedText}
      </span>
    `;
  }
  
  dateRenderer(params: any) {
    if (!params.value) return '';
    const date = new Date(params.value);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  dateComparator(valueA: string, valueB: string) {
    const parseDate = (value: string) => {
      if (!value) return null;
      // Agar backend se yyyy-mm-dd aa raha hai:
      if (value.includes('-') && value.indexOf('-') === 4) {
        return new Date(value).getTime();
      }
      // Agar already dd-mm-yyyy format hai:
      const [day, month, year] = value.split('-').map(Number);
      return new Date(year, month - 1, day).getTime();
    };

    const dateA = parseDate(valueA);
    const dateB = parseDate(valueB);

    if (dateA === dateB) return 0;
    if (dateA == null) return -1;
    if (dateB == null) return 1;
    return dateA - dateB;
  }

  openFile(fileUrl: string) {
    window.open(fileUrl, '_blank');
  }
  downloadRenderer = (params: any) => {
    
    const fileUrl = `${this.config.downloadFile}${params.value}`;
    if (!params.value) return '';
    const img = document.createElement('img');
    img.src = 'assets/icon/yellowdownload.png'; // replace with your icon path
    img.alt = 'download';
    img.style.width = '18px';
    img.style.height = '18px';
    img.style.cursor = 'pointer';
    img.title = params.value;
    img.addEventListener('click', (e) => {
      e.stopPropagation();
      // open file in new tab
      window.open(fileUrl, '_blank');
    });
    return img;
  }

    // Helper function to convert any date string into dd-MM-yyyy
    formatDateOnly(dateStr: string | null): string | null {
      if (!dateStr) return null;
    
      let datePart = dateStr;
      if (dateStr.includes('T')) {
        datePart = dateStr.split('T')[0];  
      }
    
      const [y, m, d] = datePart.split('-').map(Number);
      if (!y || !m || !d) return null;
    
      // Date object 
      const date = new Date(y, m - 1, d);
    
      // Format dd-MM-yyyy
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${year}-${month}-${day}`;
    }

  downloadDialogRenderer(fileName: string): string {
    if (!fileName) return '';
    return `${this.config.downloadFile}${fileName}`;
  }
  selectedRow: any;
  isDetailsOpen = false;
  onRowClicked(event: any) {
    this.selectedRow = event.data;
    this.isDetailsOpen = true;
  }
  closeDetails() {
    this.isDetailsOpen = false;
  }

 isClicked = false;
 

  resetGrid() {
    this.isClicked = true; // Trigger animation
  
    if (this.gridApi) {
      // ✅ Reset filters & sorting
      this.gridApi.setFilterModel(null);
      // this.gridApi.setSortModel(null);
      this.gridApi.deselectAll();
  
      // ✅ Reset quick filter (search box)
      this.searchTaskString = '';
      this.gridApi.setGridOption('quickFilterText', ''); // Clears quick filter text
  
      // ✅ Reset pagination
      this.paginationPageSize = 10;
      this.gridApi.setGridOption('paginationPageSize', this.paginationPageSize);
      this.gridApi.paginationGoToFirstPage();
  
      // ✅ Force refresh so UI input also clears
      this.gridApi.refreshCells();
      this.gridApi.resetColumnState();         // ✅ Reset columns
    }
  }
// --------------------------------AG GRID CODE---------------------------------------------------------
   

  getEmployee() {

    const request = {
      "companyId": this.loggedInUserCompanyID,
      "userId": this.loggedInUserId
    };
    this.httpService.callPostService(this.config.getTeamOfManager, request).subscribe((data: any) => {
      this.employeIDFromUserTable = data.data;

    })

  }

  viewDocument(fileUrl: string): void {

    if (fileUrl) {
      // Open the document in a new tab
      fileUrl = `${this.config.downloadFile}${fileUrl}`;
      window.open(fileUrl, '_blank');
    } else {
      console.error('No document URL available');
    }
  }

  hederlable() {

    const taskColumnHeaderInfoForFinanceHRAdmin = [
      { headerName: 'Employee Name', isMandatory: true,minWidth: 190 , filter: 'agSetColumnFilter', field: 'employeeName' },
      { headerName: 'Reimbursement Type', isMandatory: true,minWidth: 220 , filter: 'agSetColumnFilter', field: 'reimbursementType' },
      {
        headerName: 'Date of Apply',
        field: 'date',
        cellRenderer: (params: any) => this.dateRenderer(params),
        comparator: (valueA: string, valueB: string) => this.dateComparator(valueA, valueB),
        filter: 'agDateColumnFilter',
        minWidth: 165,
        filterParams: {
          filterOptions: ['equals', 'inRange', 'blank', 'notBlank'],
          suppressAndOrCondition: true,  // ✅ AND/OR hide
          maxNumConditions: 1            // ✅ Sirf ek condition allow hogi
        }
      },
      {
        headerName: 'Date of Expense',
        isMandatory: true,
        field: 'dateOfExpense',
        cellRenderer: (params: any) => this.dateRenderer(params),
        comparator: (valueA: string, valueB: string) => this.dateComparator(valueA, valueB),
        filter: 'agDateColumnFilter',
        minWidth: 180,
        filterParams: {
          filterOptions: ['equals', 'inRange', 'blank', 'notBlank'],
          suppressAndOrCondition: true,  // ✅ AND/OR hide
          maxNumConditions: 1            // ✅ Sirf ek condition allow hogi
        }
      },
      { headerName: 'Limit of Reimbursement', isMandatory: true,minWidth: 230 , filter: 'agSetColumnFilter', field: 'reimbursementLimit' },
      { headerName: 'Actual Amount', isMandatory: true,minWidth: 180 , filter: 'agSetColumnFilter', field: 'actualAmount' },
      { headerName: 'Actual Amount By Finance', isMandatory: true,minWidth: 250 , filter: 'agSetColumnFilter', field: 'assignedAmount' },
      { headerName: 'Attachment', isMandatory: true, field: 'uploadDocument', cellRenderer: (params: any) => this.downloadRenderer(params), filter: false,minWidth: 135 },
      {
        headerName: 'Status',
        field: 'status',
        cellRenderer: (params: any) => this.statusFormatter(params),
        filter: 'agSetColumnFilter',
        minWidth: 180,
        autoHeight: true, // ✅ ensures row height adjusts to wrapped text
        cellStyle: { whiteSpace: 'normal' }
      },
      {
        headerName: 'Employee Comment',
        isMandatory: false,
        field: 'employeeComment',
        filter: 'agSetColumnFilter',
        minWidth: 210,
        cellRenderer: (params: any) => {
          if (!params.value) return ''; // null/undefined case me blank return karega
          const shortText = params.value?.length > 30 
            ? params.value.substring(0, 30) + '...' 
            : params.value;
       
          return `<span class="clickable-comment">${shortText}</span>`;
        },
        onCellClicked: (params: any) => {
          if (params.value) {
            // console.log(params)
            params.context.componentParent.openCommentModal(params.value,'Employee');
          }
        }
      },
      {
        headerName: 'Finance Comment',
        isMandatory: false,
        field: 'financeComment',
        filter: 'agSetColumnFilter',
        minWidth: 210,
        cellRenderer: (params: any) => {
          if (!params.value) return ''; // null/undefined case me blank return karega

          const shortText = params.value?.length > 30 
            ? params.value.substring(0, 30) + '...' 
            : params.value;
       
          return `<span class="clickable-comment">${shortText}</span>`;
        },
        onCellClicked: (params: any) => {
          if (params.value) {
            // console.log(params)
            params.context.componentParent.openCommentModal(params.value,'Finance');
          }
        }
      }
      ,
      {
        headerName: 'Approval',
        isMandatory: true,
        field: 'approvedStatus',
        cellRenderer: (params: any) => this.approvalRenderer(params),
        filter: 'agSetColumnFilter',
        minWidth: 150
      }
    ];                  


    if (this.approveMatrixValueForCondition != 'EMPLOYEE_TO_FINANCE') {
      const managerCommentColumn =    {
        headerName: 'Manager Comment',
        isMandatory: false,
        field: 'managerComment',
        filter: 'agSetColumnFilter',
        minWidth: 210,
        cellRenderer: (params: any) => {
          if (!params.value) return ''; // null/undefined case me blank return karega
          const shortText = params.value?.length > 30 
            ? params.value.substring(0, 30) + '...' 
            : params.value;
       
          return `<span class="clickable-comment">${shortText}</span>`;
        },
          // ✅ Validation: 250 chars max
          valueSetter: (params: any) => {
          if (params.newValue && params.newValue.length > 250) {
            params.context.componentParent.toastr.warning(
              'Manager Comment cannot exceed 250 characters',
              'Warning'
            );
            return false; // reject update
          }
          params.data.managerComment = params.newValue;
          return true;
        },
        onCellClicked: (params: any) => {
          if (params.value) {
            // console.log(params)
            params.context.componentParent.openCommentModal(params.value,'Manager');
          }
        }
      }; 
      const employeeCommentIndex = taskColumnHeaderInfoForFinanceHRAdmin.findIndex(column => column.field === 'employeeComment');
      taskColumnHeaderInfoForFinanceHRAdmin.splice(employeeCommentIndex + 1, 0, managerCommentColumn);
    }
    // Dynamically add "Approved By" column
    if (this.moduleName == 1 && (sessionStorage.getItem('financeAdminId') == this.loggedInUserId || this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole == 'Employee')) {
      this.isApprovedByEnabled = true;
      const approvedByColumn = { headerName: 'Approved By', isMandatory: true,minWidth: 180 , filter: 'agSetColumnFilter', field: 'ApprovedBy' };
      // Insert "Approved By" before "Approval"
      const approvalIndex = taskColumnHeaderInfoForFinanceHRAdmin.findIndex(column => column.field === 'approvalStatus');
      if (approvalIndex > -1) {
        taskColumnHeaderInfoForFinanceHRAdmin.splice(approvalIndex, 0, approvedByColumn);
      }
    }

    this.taskColumnHeaderInfoForFinanse = taskColumnHeaderInfoForFinanceHRAdmin


  }

  getAllEmployeeListing() {
    console.log("logggedIN user============", this.loggedInUserRole);


    this.httpService.reimbursementData$.subscribe((resp) => {
      console.log("Dahsboard details data.....", resp);
      const rawData =  resp;
      var data = rawData.map((item: any) => ({
        ...item,
        date: this.formatDateOnly(item.date),             // ✅ always dd-MM-yyyy
        dateOfExpense: this.formatDateOnly(item.dateOfExpense) // ✅ always dd-MM-yyyy
      }));

      if (this.selectedFromDated && this.selectedtoDated) {

        const from = new Date(this.selectedFromDated).setHours(0, 0, 0, 0);
        const to = new Date(this.selectedtoDated).setHours(23, 59, 59, 999);

        data = data.filter((record: any) => {
          const recordDate = new Date(record.date).getTime();
          return recordDate >= from && recordDate <= to;
        });
        
      } 

      data = data.filter((record: any) => record.status !== 'REJECTED_BY_HR_ADMIN');
      if (this.moduleName === 3) {
        data = data.filter((record: any) =>
          record.status !== 'APPROVED_BY_MANAGER' &&
          record.status !== 'REJECTED_BY_MANAGER'
        );
      }

      if (
  (this.loggedInUserRole === 'Manager' &&
   sessionStorage.getItem('financeAdminId') == this.loggedInUserId)
) {
  data = data.filter(rec => rec.status !== 'PENDING_WITH_MANAGER');
}
      this.allTeamMemberReimbursementApprove = [];

      // this.allTeamMemberReimbursementApprove = data;
      this.employeeData = data.filter((elm: any) => elm.employeeId == this.loggedInUserId || elm.financeId == this.loggedInUserId)
      this.employeeApproved = this.employeeData.filter((elm: any) => elm.approvedStatus == 'APPROVED');
      this.employeeRejected = this.employeeData.filter((elm: any) => elm.approvedStatus == 'REJECTED');

      if (this.httpService.passApprovematrixForReport == 'EMPLOYEE_TO_FINANCE') {
        this.employeePendding = this.employeeData.filter((elm: any) => (elm.approvedStatus == 'PENDING'));
        console.log("#########Employee pending111....",    this.employeePendding)
      } else {
        this.employeePendding = this.employeeData.filter((elm: any) => (elm.approvedByManager == 'APPROVED' && elm.approvedStatus == 'PENDING'  &&  elm.status !== 'APPROVED_BY_MANAGER_SENT_TO_HR_ADMIN'));
        console.log("#########Employee pending222....",    this.employeePendding)
      }

      console.log("data--", data)

      this.employeApprovedOrRejected = this.type == "Approved" ? this.employeeApproved : this.employeeRejected
      this.approvedReimbursment = data.filter((elm: any) => elm.approvedStatus == 'APPROVED');
      this.rejectedReimbursment = data.filter((elm: any) => elm.approvedStatus == 'REJECTED')
      this.expenseApproved = this.type == "Approved" ? this.approvedReimbursment : this.rejectedReimbursment;
      this.penddingReimbursment = data.filter((elm: any) => (elm.approvedStatus == 'PENDING' && elm.approvedByManager == 'APPROVED' &&  elm.status !== 'APPROVED_BY_MANAGER_SENT_TO_HR_ADMIN'));
      console.log("@@@@@@@@@@Pending by Finance for HR Admin ..",   this.penddingReimbursment)
      //----------------------------------- Start manager----------------------------------------
      
      let ManagerEmployeeDorpDownData = data.filter((record: any) => record.employeeId == this.selectUserIdForManager);
      this.raisedEmployeeUnderManager = data.filter((record: any) => record.employeeId == this.selectUserIdForManager);

      this.pendingWithManager = this.raisedEmployeeUnderManager.filter((record: any) => (record.approvedByManager == null || record.approvedByManager == 'PENDING') && this.loggedInUserId != record.employeeId);


      this.approvedEmployeeUnderManager = this.raisedEmployeeUnderManager.filter((record: any) => record.approvedStatus == 'APPROVED');
      this.rejectedEmployeeUnderManager = this.raisedEmployeeUnderManager.filter((record: any) => record.approvedStatus == 'REJECTED');
      this.pendingEmployeeUnderManager = this.raisedEmployeeUnderManager.filter((record: any) => (record.approvedByManager == 'APPROVED' && record.approvedStatus == 'PENDING' &&   record.status !== 'APPROVED_BY_MANAGER_SENT_TO_HR_ADMIN'));
      this.pendingEmployeeUnderManager = (this.moduleName === 'Manager' || this.loggedInHODManager == 'HODManager') ? this.pendingWithManager : this.pendingEmployeeUnderManager;

      this.underManagerAprrovedreject = this.type == "Approved" ? this.approvedEmployeeUnderManager : this.rejectedEmployeeUnderManager;
      //-----------------------------------end manager----------------------------------------
      //----------------------------------- Start finance----------------------------------------

      let employeeIds = this.employeIDFromUserTable.map((elm: any) => elm.id)


      let FinanceDorpDownData = data.filter((record: any) => employeeIds.includes(record.employeeId) || record.financeId == this.loggedInUserId);

      if (this.httpService.passApprovematrixForReport == 'EMPLOYEE_TO_FINANCE') {

        this.raisedEmployeeUnderFinance = data.filter((elm: any) => ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId))))

        this.approvedEmployeeUnderFinance = this.raisedEmployeeUnderFinance.filter((record: any) => record.approvedStatus == 'APPROVED');
        this.rejectedEmployeeUnderFinance = this.raisedEmployeeUnderFinance.filter((record: any) => record.approvedStatus == 'REJECTED');
        this.pendingEmployeeUnderFinance = this.raisedEmployeeUnderFinance.filter((record: any) => (record.approvedStatus == 'PENDING'));

      } 
      
      
      else {

        // this.raisedEmployeeUnderFinance = data.filter((elm: any) => elm.approvedByManager === "APPROVED" && ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId))) )
        this.raisedEmployeeUnderFinance = data.filter((elm: any) => 
          ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId))) &&
         ( elm.status !== "APPROVED_BY_MANAGER_SENT_TO_HR_ADMIN") // 🚫 Restrict here too
        );
        console.log("Raised 000000000000.....",    this.raisedEmployeeUnderFinance)
        this.approvedEmployeeUnderFinance = this.raisedEmployeeUnderFinance.filter((record: any) => record.approvedStatus == 'APPROVED' && record.financeId == this.loggedInUserId);
        this.rejectedEmployeeUnderFinance = this.raisedEmployeeUnderFinance.filter((record: any) => record.approvedStatus == 'REJECTED' && record.financeId == this.loggedInUserId);
        this.pendingEmployeeUnderFinance = this.raisedEmployeeUnderFinance.filter((record: any) => (record.approvedByManager == 'APPROVED' && record.approvedStatus == 'PENDING' &&
          record.status !== "APPROVED_BY_MANAGER_SENT_TO_HR_ADMIN"));
       
      }

      this.underFinanceAprrovedreject = this.type == "Approved" ? this.approvedEmployeeUnderFinance : this.rejectedEmployeeUnderFinance;
      console.log("--------------------sessionStorage.getItem('financeAdminId')-----------------------------",sessionStorage.getItem('financeAdminId'))
      //-----------------------------------end Finance----------------------------------------
      if (this.loggedInUserRole == 'Employee' && sessionStorage.getItem('financeAdminId') != this.loggedInUserId) {
        console.log("=========== EMPLOYEE LOGIN ===========");
        console.log("Logged in Employee ID:", this.loggedInUserId);
        console.log("Raw Employee Data:", data);
        const arrExpensData = this.employeeData;

        arrExpensData.forEach((expense: { financeId: { toString: () => any; }; financeName: string; }) => {
          let matchingUser = this.arrEmployeeDetiails.find((user: any) =>
            user.id.toString() === expense.financeId?.toString() // Ensure both are strings
          );
         
          
          if (matchingUser) {
            expense.financeName = `${matchingUser.firstName} ${matchingUser.lastName}`;
          } else {
            expense.financeName = '';
          }
        });



        this.allTeamMemberReimbursementApprove = this.moduleName === 1 ? arrExpensData :
          this.moduleName === 4 ? this.employeePendding : this.employeApprovedOrRejected;
        this.currentData = this.allTeamMemberReimbursementApprove;
        ManagerEmployeeDorpDownData = this.allTeamMemberReimbursementApprove;
        
    console.log("Employee -Assigned the current data here ....:", this.currentData);
    console.log("Employee Approved data :", this.employeeApproved);
    console.log("Employee rejected daaaaaata:", this.employeeRejected);
    console.log("Employee pending data:", this.employeePendding);
    console.log("=====================================");

      }else if ((this.loggedInUserRole == 'HOD' || this.loggedInHODManager == 'HODManager') && sessionStorage.getItem('financeAdminId') != this.loggedInUserId) {
        
        if(this.loggedInHODManager == 'HODManager'){
          
        this.allTeamMemberReimbursementApprove = this.moduleName === 1 ? this.raisedEmployeeUnderManager :
        (this.moduleName === 4 || ( this.loggedInHODManager == 'HODManager')) ? this.pendingEmployeeUnderManager : this.underManagerAprrovedreject;
      this.currentData = this.allTeamMemberReimbursementApprove;
      ManagerEmployeeDorpDownData = this.allTeamMemberReimbursementApprove;
        }else{
          const arrExpensData = this.employeeData;
 
        arrExpensData.forEach((expense: { financeId: { toString: () => any; }; financeName: string; }) => {
          let matchingUser = this.arrEmployeeDetiails.find((user: any) =>
            user.id.toString() === expense.financeId?.toString() // Ensure both are strings
          );
          if (matchingUser) {
            expense.financeName = `${matchingUser.firstName} ${matchingUser.lastName}`;
          } else {
            expense.financeName = '';
          }
        });

        
        

        this.allTeamMemberReimbursementApprove = this.moduleName === 1 ? arrExpensData :
          this.moduleName === 4 ? this.employeePendding : this.employeApprovedOrRejected;
        this.currentData = this.allTeamMemberReimbursementApprove;
        ManagerEmployeeDorpDownData = this.allTeamMemberReimbursementApprove;
        }
        

      } else if ((this.loggedInUserRole == 'Manager' || this.loggedInHODManager == 'HODManager') && sessionStorage.getItem('financeAdminId') != this.loggedInUserId) {
        console.log("inside manager Not Finance");

        this.allTeamMemberReimbursementApprove = this.moduleName === 1 ? this.raisedEmployeeUnderManager :
          (this.moduleName === 4 || (this.moduleName === 'Manager' || this.loggedInHODManager == 'HODManager')) ? this.pendingEmployeeUnderManager : this.underManagerAprrovedreject;
        this.currentData = this.allTeamMemberReimbursementApprove;
        ManagerEmployeeDorpDownData = this.allTeamMemberReimbursementApprove;
      }
      
      else if (sessionStorage.getItem('financeAdminId') == this.loggedInUserId) {
        console.log("inside... Finance ");
        const arrExpensData = data.filter((record: any) =>
          record.financeId == this.loggedInUserId   ||  record.status === "APPROVED_BY_MANAGER_SENT_TO_FINANCE"  || record.approvedStatus === "PENDING"  &&
  record.status !== "APPROVED_BY_MANAGER_SENT_TO_HR_ADMIN"
        );
   
        arrExpensData.forEach(expense => {
          let matchingUser = this.arrEmployeeDetiails.find((user: any) =>
            user.id.toString() === expense.financeId?.toString() // Ensure both are strings
          );
          if (matchingUser) {
            expense.financeName = `${matchingUser.firstName} ${matchingUser.lastName}`;
          } else {
            expense.financeName = '';
          }
        });
   


        this.allTeamMemberReimbursementApprove = this.moduleName === 1 ? arrExpensData :
          this.moduleName === 4 ? this.pendingEmployeeUnderFinance : this.underFinanceAprrovedreject;
        this.currentData = this.allTeamMemberReimbursementApprove;


        ManagerEmployeeDorpDownData = this.allTeamMemberReimbursementApprove;
      }
      else {
        console.warn("HR ADMIN")
        console.log("---------------------",this.loggedInUserRole);
        
        const arrExpensData = data;

        arrExpensData.forEach((expense: { financeId: { toString: () => any; }; financeName: string; }) => {
          let matchingUser = this.arrEmployeeDetiails.find((user: any) =>
            user.id.toString() === expense.financeId?.toString() // Ensure both are strings
          );
          if (matchingUser) {
            expense.financeName = `${matchingUser.firstName} ${matchingUser.lastName}`;
          } else {
            expense.financeName = '';
          }
        });
        console.log(this.expenseApproved)
        this.allTeamMemberReimbursementApprove = this.moduleName === 1 ? arrExpensData : this.moduleName === 4 ? this.penddingReimbursment : this.expenseApproved;
        this.currentData = this.allTeamMemberReimbursementApprove;
        ManagerEmployeeDorpDownData = this.allTeamMemberReimbursementApprove;
      }
      this.getStatusList = ManagerEmployeeDorpDownData
        .map((ele: any) => ({
          id: ele.reimbursementApplicationId,
          name: ele.approvedStatus
        }))
        .filter((value, index, self) =>
          index === self.findIndex((t) => (
            t.name === value.name
          ))
        );

    })


  }
  // Budget vs actual Increment Graph 

  onSelectStatus() {
    if (this.selectedSatus.length > 0) {

      this.filterSatus();
    }
  };

  onDeSelectStatus() {
    this.filterSatus();
  };

  selectAllStatus(data: any) {
    console.log(data);

    this.onSelectStatus();
  };

  onDeSelectAllStatus() {
    this.filterSatus();
    this.selectedSatus = [];

  };

  filterSatus() {
    if (this.selectedSatus.length > 0) {
      const status = this.selectedSatus.map((record: any) => record.name);
      this.allTeamMemberReimbursementApprove = this.currentData.filter((elm: any) => status.includes(elm.approvedStatus));
      console.log(this.allTeamMemberReimbursementApprove);

    } else {
      this.allTeamMemberReimbursementApprove = this.currentData;
    }
  }


  exportDashboardListExcel() {
    if (!this.allTeamMemberReimbursementApprove.length) {
      alert('No data to download!');
      return;
    }

    // Define the fields to be downloaded
    const exportFields = [
      'employeeName',
      'reimbursementType',
      'date',
      'dateOfExpense',
      'reimbursementLimit',
      'actualAmount',
      'assignedAmount',
      'uploadDocument',
      'status',
      'employeeComment',
      'financeComment',
      //'financeName',

      'approvedStatus'
    ];

    // Extract headers for the selected fields

    if (this.approveMatrixValueForCondition !== 'EMPLOYEE_TO_FINANCE') {
      const financeCommentIndex = exportFields.indexOf('financeComment');
      if (financeCommentIndex !== -1) {
        exportFields.splice(financeCommentIndex, 0, 'managerComment');
      }
    }
    // Conditionally include 'financeName' in export
    if (
      this.moduleName == 1 &&
      (sessionStorage.getItem('financeAdminId') == this.loggedInUserId ||
        this.loggedInUserRole === 'HR Admin' ||
        this.loggedInUserRole === 'Employee')
    ) {
      const approvedStatusIndex = exportFields.indexOf('approvedStatus');
      if (approvedStatusIndex > -1) {
        exportFields.splice(approvedStatusIndex, 0, 'financeName');
      }
    }


    const header = this.taskColumnHeaderInfoForFinanse.map((column: any) => column.label);
    // Extract rows with only the selected fields
    let dateChgeArray: any = [];
    dateChgeArray = this.allTeamMemberReimbursementApprove.map((elm: any) => {
      return {
        ...elm,
        date: this.datePipe.transform(elm.date, 'dd-MM-yyyy'),
        status: formatText(elm.status)
      }
    })
    const rows = dateChgeArray.map((record: any) =>

      exportFields.map(field => `"${record[field] || ''}"`).join(',')
    );

    // Create the CSV content
    const csvContent = [header, ...rows].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const data = this.type == 'Approved' ? 'Expense Approved' : 'Expense Rejected';
    const moduleName = this.moduleName == 1 ? 'Expense Raised' : (this.moduleName == 4 || this.moduleName == 'Manager'  || this.loggedInHODManager == 'HODManager' ) ? 'Expense Pending' : data;
    // Trigger the download
    const a = document.createElement('a');
    a.href = url;
    a.download = `${moduleName}${new Date()}`
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }


  onChangeSwitch(event: any) {
    this.isToggleOn = event?.checked;

    if (event?.checked == true) {
      this.type = 'Approved';
      if ((this.moduleName == 3) && event?.checked == true) {
        this.type = 'Approved';
      }
      this.getAllEmployeeListing()
    } else if (event?.checked == false) {
      this.type = 'Rejected';
      if ((this.moduleName == 3) && event?.checked == false) {
        this.type = 'Rejected';
      }
      this.getAllEmployeeListing()
    }
  }
}
